<section class="section contact" id='contact'>
    <div class="container">
        <div class="section-box">
            <div class="mb-4" data-aos="fade-up" data-aos-duration="1000">
                <h3 class="contact-pre-title big-subtitle">05. {{"Contact.Pretitle" | translate}}</h3>
                <h4 class="e-font contact-title big-title">
                    ¡Saludame!
                </h4>
            </div>
            <div data-aos="fade-up" data-aos-duration="1000">
            <p>{{saludoDesc?.description}}</p>
                
            <div class="mt-5">
                <a (click)='analyticsService.sendAnalyticEvent("click_send_mail", "contact", "email")' href="mailto:testmail@mail.com" target="_blank" class="main-btn" data-aos="fade-up" data-aos-duration="1000">
                    Contáctame
                </a>
            </div>
            </div>
        </div>
    </div>
</section>